import { startCase } from 'lodash-es';

import { IconTooltipItem } from '~/domain';
import { PlanType } from '~/services';

export function getPlanLabel(orgPlan: PlanType): string {
	switch (orgPlan) {
		case PlanType.MY_EXPENSE:
			return 'mySilae Expense';
		case PlanType.SILAE_EXPENSE:
			return 'Silae Expense';
		case PlanType.SILAE_EXPENSE_PRO:
			return 'Silae Expense Pro';
		default:
			console.error('Unknown organization plan: ', orgPlan);
			return startCase(orgPlan);
	}
}

export function getChiftIcon(chiftLabel: string): IconTooltipItem | undefined {
	return chiftLabel ? { label: chiftLabel, icon: 'sitemap' } : undefined;
}
